import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const TURKEY_BOUNDS = L.latLngBounds(
  [35.8, 25.6], // güneybatı
  [42.3, 45.0]  // kuzeydoğu
);

const markerIconDefault = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const hasValidCoords = (lat, lng) => {
  const nLat = Number(lat);
  const nLng = Number(lng);
  return (
    lat !== null &&
    lat !== undefined &&
    lat !== '' &&
    lng !== null &&
    lng !== undefined &&
    lng !== '' &&
    !Number.isNaN(nLat) &&
    !Number.isNaN(nLng)
  );
};

/**
 * Madde önizlemede seçilen konumu gösterir. Harita Türkiye sınırlarıyla kısıtlıdır.
 */
function ItemLocationMap({ lat, lng, title = '', height = 320 }) {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);

  useEffect(() => {
    if (!mapRef.current) return;

    if (mapInstance.current) {
      mapInstance.current.remove();
      mapInstance.current = null;
    }

    const nLat = Number(lat);
    const nLng = Number(lng);
    const valid = hasValidCoords(lat, lng);
    const point = valid ? L.latLng(nLat, nLng) : null;
    const inTurkey = point && TURKEY_BOUNDS.contains(point);

    const map = L.map(mapRef.current, {
      maxBounds: TURKEY_BOUNDS,
      maxBoundsViscosity: 1.0,
      minZoom: 5,
      maxZoom: 18,
      scrollWheelZoom: false,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      bounds: TURKEY_BOUNDS,
    }).addTo(map);

    // Ekranda Türkiye'nin tamamı görünsün
    map.fitBounds(TURKEY_BOUNDS, { padding: [10, 10] });
    map.setMaxBounds(TURKEY_BOUNDS);

    if (valid && inTurkey) {
      L.marker([nLat, nLng], { icon: markerIconDefault })
        .bindPopup(
          title
            ? `${title}<br/>${nLat.toFixed(6)}, ${nLng.toFixed(6)}`
            : `${nLat.toFixed(6)}, ${nLng.toFixed(6)}`
        )
        .addTo(map)
        .openPopup();
    }

    mapInstance.current = map;

    // Dialog/layout sonrası boyut hesaplaması ve Türkiye sınırlarını yeniden sığdır
    setTimeout(() => {
      map.invalidateSize();
      map.fitBounds(TURKEY_BOUNDS, { padding: [10, 10] });
    }, 150);

    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove();
        mapInstance.current = null;
      }
    };
  }, [lat, lng, title]);

  if (!hasValidCoords(lat, lng)) {
    return (
      <div className="alert alert-light border mb-0">
        Bu madde için kayıtlı konum bulunmamaktadır.
      </div>
    );
  }

  return (
    <div
      ref={mapRef}
      style={{
        height,
        width: '100%',
        borderRadius: 4,
        border: '1px solid #e0e0e0',
      }}
    />
  );
}

export default ItemLocationMap;
